import {RoomCall} from "@/core/api/room.call.api";
import {Room} from "@/core/api/room.api";
import {roomCallService} from "@/core/service/room.call.service";
import {RoomCallMixerApi} from "@/core/api/room.call.mixer.api";

const CALL_TYPE = 'mixer-sfu';
class RoomCallMixerSFUApi extends RoomCallMixerApi {

    constructor() {
        super({
            apiName: 'MixerSFU', callType: CALL_TYPE
        });
        // RoomCall.MixerSFU = this;

        // this._Events = Object.assign(this._Events || {}, _Events());
        this._Events = _Events();
        RoomCall.addCallTypeEventListener(CALL_TYPE, this._Events, this);

        Room.addEventListeners(_CoreEvents(), this);

        Room.addEventListener('room_core_call_infoLoaded', e => {
            if (!this.isSFU()) {
                return;
            }
            // TODO callType 변경 이후 client 에서 enter call 을 하도록 바뀌면서 서버 타이밍과 안맞게 된다. 임시 딜레이
            setTimeout(() => {
                RoomCall._enterCall();
            }, 500);;
        });
    }

    isMixing(current) {
        return super.isMixing(current)
            || Room.getRoomData().roomCall.callType === CALL_TYPE
    }

    isSFU() {
        let roomCall = Room.getRoomData().roomCall
        return roomCall.callType === CALL_TYPE
    }

    getMixer() {
        return super.getMixer()
            || RoomCall.Mixer.getMixer();
    }

    createMixerWebRTCConnection(mixer, options={}) {
        const conn = super.createMixerWebRTCConnection(mixer, options={});
        conn.userBitrate = {
            current: {
                reset: function(){
                    Object.assign(this, {
                        userId: null,
                        bitrate: null, framerate: null
                    })
                }
            },
            list: [],
            obj: {}
        }

        conn.addEventListener('track', e => {
            if(!this.isSFU()){
                return;
            }

            console.log('# peer.%s mixer : id[%s], k[%d]',
                e.type
                , e.track.id
                , e.track.kind
                , e
            );

            const conn = mixer.conn;
            const {track} = e;

            let userId = (() => {
                // mixer 에서 tranceiver handle 이 안되어 custom 하게 처리
                if(conn.sfuStreams){
                    const trans = conn.getPeerConnection().getTransceivers().find(t => t.receiver.track === track);
                    if(trans){
                        const key = 'sfu'
                            + (track.kind === 'audio' ? 'Audio' : 'Video')
                            + 'TrackId';
                        const data = conn.sfuStreams.find(s => s[key] === trans.mid);
                        if(data){
                            return data.userId;
                        }
                    }
                }

                return track.id.substring( track.id.lastIndexOf('_') + 1 );
            })();

            let streamUser = userId && Room.User.getRoomUser(userId);

            // parse streamUser
            if(!streamUser){
                // external : stream_@@(sim)100000
                if(userId.indexOf('@@(') === 0){
                    let tIdx = userId.indexOf(')', 3),
                        temp = userId.substring(3, tIdx);
                    let name = userId, type;

                    switch(temp){
                        case 'vip':
                        case 'vad':
                            userId = userId.substring(tIdx+1);
                            break;
                        case 'videolow':
                        case 'videooff':
                            userId = userId.substring(tIdx+1);
                            break;
                        default:
                            type = temp;
                            name = userId.substring(tIdx+1);
                            break;
                    }

                    streamUser = {
                        externalType: type,
                        userId: userId,
                        name: name,
                        nickname: name
                    };
                }else{
                    if(track.id.includes('_secondary_')){
                        let stream = conn.secondStream = conn.secondStream || new MediaStream();
                        stream.addTrack(track);

                        // if(!track.muted){
                            let screenShareRoomUser = Room.Call.getScreenShareUser();
                            if(screenShareRoomUser){
                                Room.emit({
                                    type: 'room_call_screenShare',
                                    userId: screenShareRoomUser.userId,
                                    data: {
                                        screenShare: true
                                    }
                                })
                            }
                        // }
                        return;
                    }else if(track.id.endsWith(Room.getRoomData().room.roomId)){
                        let stream = conn.stream = conn.stream || new MediaStream();
                        stream.addTrack(track);
                        return;
                    }
                }

                console.warn('# streamUser not found :', track.id, track);
                return;
            }

            userId = streamUser.userId;
            conn.userStreams = conn.userStreams || {};
            const stream = conn.userStreams[userId] = conn.userStreams[userId] || new MediaStream();

            (() => {
                let bTrack = stream.getTracks().find(t => t.kind === track.kind);
                if(!bTrack) return;
                stream.removeTrack(bTrack);
            })();
            stream.addTrack(track);

            if(track.kind === 'audio'){
                Room.emit('room_call_addUserAudioTrack', {userId, track});
                RoomCall.setAudioTrackVolumeEvent({
                    userId,
                    stream
                });
            }
            Room.emit('room_call_userVideoStream', {userId, stream});
        });

        return conn;
    }

    getUserStream({userId}) {
        const mixer = this.getMixer();
        if(!mixer || !mixer.conn || !mixer.conn.userStreams) return;
        const stream = mixer.conn.userStreams[userId];
        return stream;
    }

    async changeUserVideoSenderMaxBitrate({userId=null, bitrate, framerate}) {
        const mixer = this.getMixer();
        if(!mixer || !mixer.conn?.getPeerConnection()){
            return;
        }

        const conn = mixer.conn;
        const mid = await (async () => {
            const localStream = await RoomCall.Stream.getCurrentLocalStream();
            const track = localStream && localStream.getVideoTracks()[0];
            if(!track) return;
            const trans = conn.getTransceiverByTrack(track);
            return trans?.mid;
        })();
        if(!mid){
            return;
        }

        Object.assign(conn.userBitrate.current, {
            userId, bitrate, framerate
        });
        await conn.changeSenderRTCRtpEncodingParameters(mid, {
            bitrate, framerate
        });
    }
}

function _Events(){
    return {
        room_user_enter: function(e){
            // if(!this.isSFU()){
            //     return;
            // }
            const userId = e.data.roomUser.userId;
            const stream = this.getUserStream({userId});
            if(stream){
                const roomUser = Room.User.getRoomUser(userId);
                Room.emit('room_call_addRemoteStream', {roomUser, stream});
            }
        },
        room_user_leave: async function(e){
            const userBitrate = this.getMixer()?.conn?.userBitrate;
            const {userId} = e.data;
            const userConfig = userBitrate.obj[userId];
            if(!userConfig){
                return;
            }

            // remove
            delete userBitrate.obj[userId];
            const idx = userBitrate.list.findIndex(uc => uc.userId === userId);
            if(idx > -1){
                userBitrate.list.splice(idx, 1);
            }

            if(userBitrate.list.length === 0){
                await this.changeUserVideoSenderMaxBitrate({bitrate:0, framerate:1});
                return;
            }

            if(userBitrate.current.bitrate !== userConfig.bitrate){
                return;
            }

            userBitrate.list.sort((a,b) => {
                return b.bitrate - a.bitrate;
            });
            await this.changeUserVideoSenderMaxBitrate(userBitrate.list[0]);
        },
        room_call_offer: async function(e){
            Object.assign(e.data, {
                videoWidth: 640,
                videoHeight: 360,
                bitRate: null,
            });
            if(e.data.secondVideo){
                Object.assign(e.data.secondVideo, {
                    // bitRate: null,
                });
            }

            await RoomCall.Mixer._Events.room_call_offer.apply(this, arguments);

            const mixer = this.getMixer();
            mixer.conn.sfuStreams = e.data.sfuStreams;
        },
        room_call_screenShare: async function(e){
            Room.emit(e);
        },
        room_call_changeUserVideoSenderMaxBitrate: async function(e){
            const mixer = this.getMixer();
            if(!mixer || !mixer.conn?.getPeerConnection()){
                return;
            }

            const userId = e.userId;
            const data = e.data;
            const conn = mixer.conn;
            const userBitrate = conn.userBitrate;
            let {bitrate, framerate} = data;

            // 참여자 설정값. 참여자 별로 기록해 두고 최대값 유지.
            (() => {
                let userConfig = userBitrate.obj[userId];
                if(!userConfig){
                    userConfig = userBitrate.obj[userId] = Object.assign({}, data);
                    userBitrate.list.push(userConfig);
                }else{
                    if(userConfig.bitrate === bitrate && userConfig.framerate === framerate){
                        return;
                    }
                    Object.assign(userConfig, data);
                }
            })();

            // 현재값 비고
            // 현재 max 요청한 참여자가 변경
            if(userBitrate.current.userId === userId){
                // bitrate 가 다르면 삭제 후 현재 참여자 중 최대값으로 설정
                if(userBitrate.current.bitrate !== bitrate){
                    // userBitrate.current.reset();

                    userBitrate.list.sort((a,b) => {
                        return b.bitrate - a.bitrate;
                    });
                    Object.assign(data, userBitrate.list[0]);
                }
            }
            // 현재 최대값 참여자와 다른 참여자
            else{
                // max value
                if(bitrate < userBitrate.current.bitrate){
                    return;
                }
                if(framerate < userBitrate.current.framerate){
                    return;
                }
            }

            // set current
            Object.assign(userBitrate.current, {userId, bitrate, framerate});
            await this.changeUserVideoSenderMaxBitrate({userId, bitrate, framerate});
        },
    }
}

function _CoreEvents(){
    return (() => {
        const EVENTS = {
            room_core_call_changeVideoSenderMaxBitrate: async function(e){
                const {userId, bitrate, framerate} = e.data;

                if(Room.User.isMe(userId)){
                    return;
                }
                const roomUser = Room.User.getRoomUser(userId);
                if(!roomUser){
                    console.log('roomUser is null :', userId);
                    return;
                }

                const stream = this.getUserStream({userId});
                if(!stream){
                    return;
                }
                if(stream._bw?.video == bitrate){
                    return;
                }

                roomCallService.changeUserVideoSenderMaxBitrate({
                    userId,
                    bitrate, framerate
                });
            },
            room_core_call_changeSecondVideoSenderMaxBitrate: async function(e){
                await this.changeSecondVideoSenderMaxBitrate(e.data);
            },
            room_core_call_getUserVideoStream: function(e){
                const {userId, callback} = e.data;
                const stream = this.getUserStream({userId})
                callback(stream);
            },
            room_core_call_getUserSecondStream: function(e){
                const mixer = this.getMixer();
                if(!mixer || !mixer.conn){
                    return;
                }

                const {userId, callback} = e.data;
                callback(mixer.conn.secondStream);
            }
        }

        for(let eventType in EVENTS){
            const func = EVENTS[eventType];
            EVENTS[eventType] = function(e){
                if(!this.isMixing(true) && e.data?.ignoreCallType !== true){
                    return;
                }
                return func.apply(this, arguments);
            }
        }
        return EVENTS;
    })();
}

export const RoomCallMixerSFU = new RoomCallMixerSFUApi();